

export default {
  "0" : "หญิง",
  "1" : "ชาย",
  "" : ""
}
